import { BookingType } from '@/@type/booking';
import type { MuiTelInputCountry } from 'mui-tel-input';
import { DATA_TIMEZONE } from '@/utils/dataTimezone';

export const BOOKING_ONBOARDING_AUTO_ASSIGN = BookingType.AutoAccept;
export const BOOKING_ONBOARDING_MANUAL_ASSIGN = BookingType.ManuallyAccept;

export const BOOKING_ONBOARDING_BOOKING_TYPE_OPTIONS = [BOOKING_ONBOARDING_AUTO_ASSIGN, BOOKING_ONBOARDING_MANUAL_ASSIGN] as const;

export const BOOKING_ONBOARDING_BOOKING_TYPE_LABEL_KEYS = {
    [BOOKING_ONBOARDING_AUTO_ASSIGN]: 'bookingOnboarding.bookingTypes.autoAssign',
    [BOOKING_ONBOARDING_MANUAL_ASSIGN]: 'bookingOnboarding.bookingTypes.manualAssign'
} as const;

export const BOOKING_ONBOARDING_DEFAULT_PHONE_COUNTRY: MuiTelInputCountry = 'AU';

export const BOOKING_ONBOARDING_DEFAULT_TIMEZONE = 'Australia/Sydney';

export const BOOKING_ONBOARDING_TIMEZONE_OPTIONS = DATA_TIMEZONE.map((option) => {
    const firstLetter = option.label.toUpperCase();
    return {
        firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
        ...option
    };
});

export const BOOKING_ONBOARDING_VALID_TIMEZONE_CODES = DATA_TIMEZONE.map((timezone) => timezone.tzCode);

export const BOOKING_ONBOARDING_INITIAL_VALUES = {
    restaurantName: '',
    email: '',
    contactCountry: BOOKING_ONBOARDING_DEFAULT_PHONE_COUNTRY,
    contact: '',
    ownerManagerName: '',
    diningDuration: '',
    bookingSlotInterval: '',
    minimumAdvanceBookingTime: '',
    sessionMaxCapacity: '',
    timezone: BOOKING_ONBOARDING_DEFAULT_TIMEZONE,
    bookingType: '',
    maxPaxPerBooking: ''
} as const;

export const BOOKING_ONBOARDING_FIELD_CONTENT = {
    restaurantName: {
        titleKey: 'bookingOnboarding.fields.restaurantName.title',
        helperKeys: ['bookingOnboarding.fields.restaurantName.helper']
    },
    email: {
        titleKey: 'bookingOnboarding.fields.email.title',
        helperKeys: ['bookingOnboarding.fields.email.helper']
    },
    contact: {
        titleKey: 'bookingOnboarding.fields.contact.title',
        helperKeys: ['bookingOnboarding.fields.contact.helper']
    },
    ownerManagerName: {
        titleKey: 'bookingOnboarding.fields.ownerManagerName.title',
        helperKeys: ['bookingOnboarding.fields.ownerManagerName.helper']
    },
    diningDuration: {
        titleKey: 'bookingOnboarding.fields.diningDuration.title',
        helperKeys: ['bookingOnboarding.fields.diningDuration.helper']
    },
    bookingSlotInterval: {
        titleKey: 'bookingOnboarding.fields.bookingSlotInterval.title',
        helperKeys: ['bookingOnboarding.fields.bookingSlotInterval.helper']
    },
    minimumAdvanceBookingTime: {
        titleKey: 'bookingOnboarding.fields.minimumAdvanceBookingTime.title',
        helperKeys: ['bookingOnboarding.fields.minimumAdvanceBookingTime.helper']
    },
    sessionMaxCapacity: {
        titleKey: 'bookingOnboarding.fields.sessionMaxCapacity.title',
        helperKeys: ['bookingOnboarding.fields.sessionMaxCapacity.helper']
    },
    timezone: {
        titleKey: 'bookingOnboarding.fields.timezone.title',
        helperKeys: ['bookingOnboarding.fields.timezone.helper']
    },
    bookingType: {
        titleKey: 'bookingOnboarding.fields.bookingType.title',
        helperKeys: ['bookingOnboarding.fields.bookingType.helper']
    },
    maxPaxPerBooking: {
        titleKey: 'bookingOnboarding.fields.maxPaxPerBooking.title',
        helperKeys: ['bookingOnboarding.fields.maxPaxPerBooking.helper']
    }
} as const;
